type Environments = 'chc' | 'local';

type Environment = {
  name: Environments;
  domains: string[];
};

// Put this in config?
const defaultEnvironments: Environment[] = [
  {
    name: 'chc',
    domains: ['chc', 'changehealthcare'],
  },
  {
    name: 'local',
    domains: ['localhost'],
  },
];

const location = window.location.origin;

export const isEnvironment = (environment: Environments): boolean => {
  const env = defaultEnvironments.find((e) => e.name === environment);
  if (!env) {
    return false;
  }
  return env?.domains.some((domain) => location.includes(domain));
};

export const getEnvironment = (): Environment | undefined =>
  defaultEnvironments.filter((environment) => environment.domains.some((domain) => location.includes(domain))).pop();
